<script>
import { onMount } from "svelte";
import { options } from "../../config";
import { PostContact } from "../../Services/form0";
import { redirect_ } from "../../Services/redirect";
import { user } from "../../store";

    var options_ = options.form0.options
    let checking = true
    let failed = false
    onMount(()=>{
        if($user.idToken){
            PostContact({form:"login",profile:options.profile,data:{}},$user.idToken,(d)=>{
                checking = false
            },(e)=>{
                console.error("Failed Login test",e)
                failed = true
            })
        }else{
            redirect_.set(options_.redirectOnAuth)
            failed = true
            checking = false
        }
        
    })
</script>

{#if checking}
    <p>Checking Loggedin Status</p>
{/if}
{#if failed}
<p>Failed to check authentication. Log in first</p>
{/if}